import { batch } from 'react-redux';

const filterAction = (d) => {
  return (dispatch) => {
    const sid = d.sid;
    let m = [];
    const f = d.allMarkers;

    if (f) {
      let i = f.length - 1;
      while (i >= 0) {
        const _id = f[i].properties.studyId
        let j = _id.length - 1
        let size = !1;
        while (j >= 0) {
          if (sid.indexOf(_id[j]) >= 0 ) {
            size++;
          }
          j--;
        }
        if (size) {
          m.push(f[i])
        }
        i--;
      }
    }

    batch(() => {
      dispatch({
        type: '_STUDY_DETAIL',
        payload: ['studyID', null]
      });
      dispatch({type:'_FILTERED',payload:['id', sid]});
      dispatch({type:'_FILTERED',payload:['label', d.label]});
      if (d.filterSlug) {
        dispatch({
          type: '_FILTERED',
          payload: ['filterSlug', d.filterSlug]
        });
      }
      dispatch({type:'_FILTERED',payload:['location', d.loc]});
      if (m.length) {
        dispatch({type:'_MARKERS',payload:['markers', m]});
      }
    })

  }
};

export default filterAction;
